import React, { useRef, useState, useEffect, useMemo } from "react";

import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import {
    Box,
    Tooltip
} from '@mui/material';
import Skeleton from '@material-ui/lab/Skeleton';
import EditIcon from '@mui/icons-material/Edit';
//Icons Imports
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Stack from '@mui/material/Stack';

import TextField from '@material-ui/core/TextField';
import { useMediaQuery, useTheme } from '@mui/material';

import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Paper from '@mui/material/Paper';

import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ReactApexChart from 'react-apexcharts';

import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import api from '../../../../../services/api.js';
import NavegadorGestao from "../../../../../components/NavBarGestao/index.js";
import moment from 'moment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';

import { parseISO } from 'date-fns';

import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';

import { Card, CardContent, Typography, Collapse } from '@mui/material';
import { ArrowUpward, ArrowDownward, MoreVert, AttachMoney, ShoppingBasket } from '@mui/icons-material';

import { Button } from "@material-ui/core";
import MetodosPagamento from '../MetodosPagamento/index';
import CondicoesPagamento from '../CondicoesPagamento/index';
import InstituicaoBancaria from '../InstituicaoBancaria/index';
import GrupoContas from '../GrupoContas/index';
import Contas from '../Contas/index';
import Taxas from '../Taxas/index';
import FluxoCaixa from '../FluxoCaixa/index';
import Parcelas from '../Parcelas/index';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import GerenciarInstituicaoBancaria from '../InstituicaoBancaria/gerenciar.js';
import Lancamentos from '../Lancamentos/index';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';


const styles = {
    card: {
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '200px',
    },
    purpleCard: {
        backgroundColor: '#6a1b9a',
        color: '#fff',
    },
    blueCard: {
        backgroundColor: '#0288d1',
        color: '#fff',
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconBackground: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        padding: '8px',
    },
    graphBox: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        height: '40px',
        marginTop: '8px',
    },

};


export default function Financeiro() {

    const [openLancamentos, setOpenLancamentos] = useState(false);

    const handleLancamentosClick = () => {
        setOpenLancamentos(!openLancamentos);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // considera mobile se for menor ou igual a 'sm'



    const regra = Cookies.get('regra');


    const handleSetInstituicaoBancariaAtualizar = (ib) => {
         setValue(100);
    }




    const handleClickAux = (event) => {
        setAnchorEl(event.currentTarget);
    };


    const [openAux, setOpenAux] = useState(false);

    const handleAuxClick = () => {
        setOpenAux(!openAux);
    };


    const handleClose = () => {
        setAnchorEl(null);
    };

    const [loading, setLoading] = useState(true);


    const [value, setValue] = useState(1);
    const [reloadKey, setReloadKey] = useState(0);

    const [totalRegistros, setTotalRegistros] = useState(0);

    const [filtro, setFiltro] = useState('');





    const [totalDespesas, setTotalDespesas] = useState(0.0);
    const [totalReceitas, setTotalReceitas] = useState(0.0);

    const [totalDespesasMesAtual, setTotalDespesasMesAtual] = useState(0.0);
    const [totalDespesasPagoMesAtual, setTotalDespesasPagoMesAtual] = useState(0.0);
    const [totalDespesasAPagarMesAtual, setTotalDespesasAPagarMesAtual] = useState(0.0);


    const [totalDespesasHoje, setTotalDespesasHoje] = useState(0.0);
    const [totalReceitasHoje, setTotalReceitasHoje] = useState(0.0);


    const [totalReceitasMesAtual, setTotalReceitasMesAtual] = useState(0.0);
    const [totalReceitasPagoMesAtual, setTotalReceitasPagoMesAtual] = useState(0.0);
    const [totalReceitasAPagarMesAtual, setTotalReceitasAPagarMesAtual] = useState(0.0);




    const hoje = new Date();
    const [mesAtual, setMesAtual] = useState(hoje.getMonth() + 1); // getMonth() retorna 0-11, então +1
    const [anoAtual, setAnoAtual] = useState(hoje.getFullYear());


    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });


    const [dados, setDados] = useState(null);
    const [dadosMesAtual, setDadosMesAtual] = useState(null);


    const [chartWidth, setChartWidth] = useState(window.innerWidth * 0.9);

useEffect(() => {
    const handleResize = () => setChartWidth(window.innerWidth * 0.9);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);


    const [dadosGrafico, setDadosGrafico] = useState({
        series: [
            { name: 'Receitas', data: [] },
            { name: 'Despesas', data: [] },
        ],
        options: {
            chart: {
                height: '100%',
                type: 'line',
                width: '100%',
                toolbar: { show: true }
            },
            colors: ['#0288d1', '#6a1b9a'],
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return currencyFormatter.format(val, { code: 'BRL' });
                },
                style: { fontSize: '12px' }
            },
            stroke: { curve: 'smooth', width: 2 },
            markers: { size: 5 },
            xaxis: { categories: [] },
            yaxis: { title: { text: 'Valores (R$)' } },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return currencyFormatter.format(val, { code: 'BRL' });
                    }
                }
            },
        }
    });


    const [graficoDespesas, setGraficoDespesas] = useState({
        series: [],
        options: {
            chart: { type: 'pie', width: '100%', toolbar: { show: true } },
            labels: [],
            legend: { position: 'bottom' },
            dataLabels: {
                formatter: val => `${val.toFixed(1)}%`
            },
            tooltip: {
                y: {
                    formatter: val => currencyFormatter.format(val, { code: 'BRL' })
                }
            }
        }
    });

    const [graficoReceitas, setGraficoReceitas] = useState({
        series: [],
        options: {
            chart: { type: 'pie', width: '100%', toolbar: { show: true } },
            labels: [],
            legend: { position: 'bottom' },
            dataLabels: {
                formatter: val => `${val.toFixed(1)}%`
            },
            tooltip: {
                y: {
                    formatter: val => currencyFormatter.format(val, { code: 'BRL' })
                }
            }
        }
    });

    // Função auxiliar para gerar cores dinâmicas
    const gerarCores = (quantidade) => {
        const cores = [];
        for (let i = 0; i < quantidade; i++) {
            const hue = (i * 360 / quantidade) % 360;
            cores.push(`hsl(${hue}, 70%, 50%)`);
        }
        return cores;
    };

    async function listar() {
        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const response = await api.get(
                `v1/protected/financeiro/dashboard?mes=${mesAtual}&ano=${anoAtual}`,
                { headers }
            );

            const respData = response.data;
            setDadosMesAtual(respData);

            api.get(`v1/protected/financeiro/dashboard?mes=${0}&ano=${0}`, {
                headers: headers
            }).then(function (response2) {
                setDados(response2.data);



                api.get(`v1/protected/financeiro/dashboardgraficomensal?ano=${anoAtual}`, {
                    headers: headers
                }).then(function (response3) {


                    const data = response3.data; // já é um array de {mes, totalDespesa, totalReceita}
                    const nomesMeses = [
                        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
                    ];

                    // Mapear os meses para o eixo X
                    const categorias = data.map(d => nomesMeses[d.mes - 1]);
                    const receitas = data.map(d => d.totalReceita);
                    const despesas = data.map(d => d.totalDespesa);

                    setDadosGrafico(prev => ({
                        ...prev,
                        series: [
                            { name: 'Receitas', data: receitas },
                            { name: 'Despesas', data: despesas },
                        ],
                        options: {
                            ...prev.options,
                            xaxis: { ...prev.options.xaxis, categorias }
                        }
                    }));


                    api.get(`v1/protected/financeiro/dashboardcontas?mes=${mesAtual}&ano=${anoAtual}`, {
                        headers: headers
                    }).then(function (response4) {


                        const data = response4.data;

                        let despesas = [];
                        let receitas = [];

                        try {
                            despesas = typeof data.jsonDespesasPorConta === 'string'
                                ? JSON.parse(data.jsonDespesasPorConta)
                                : (data.jsonDespesasPorConta || []);

                            receitas = typeof data.jsonReceitasPorConta === 'string'
                                ? JSON.parse(data.jsonReceitasPorConta)
                                : (data.jsonReceitasPorConta || []);
                        } catch (err) {
                            console.error("Erro ao converter JSON:", err);
                        }

                        // Extrai nomes e valores
                        const nomesDespesas = despesas.map(item => item.nomeConta);
                        const valoresDespesas = despesas.map(item => item.valorTotal);

                        const nomesReceitas = receitas.map(item => item.nomeConta);
                        const valoresReceitas = receitas.map(item => item.valorTotal);

                        // Gera cores diferentes
                        const coresDespesas = gerarCores(nomesDespesas.length);
                        const coresReceitas = gerarCores(nomesReceitas.length);

                        // Atualiza gráficos
                        setGraficoDespesas(prev => ({
                            ...prev,
                            series: valoresDespesas,
                            options: { ...prev.options, labels: nomesDespesas, colors: coresDespesas }
                        }));

                        setGraficoReceitas(prev => ({
                            ...prev,
                            series: valoresReceitas,
                            options: { ...prev.options, labels: nomesReceitas, colors: coresReceitas }
                        }));

                        setLoading(false);


                    });

                });


            });


        } catch (err) {
            console.log("Erro ao listar objetos: " + err)
            setLoading(false);
        }
    }
    useEffect(() => {

        listar();
    }, []);

    useEffect(() => {
        const mesInt = parseInt(mesAtual, 10);
        const anoInt = parseInt(anoAtual, 10);

        const mesValido = !isNaN(mesInt) && mesInt >= 0 && mesInt <= 12;
        const anoValido = !isNaN(anoInt) && anoInt >= 0 && anoInt <= 3000;

        if (mesValido && anoValido) {
            listar();
        }
    }, [mesAtual, anoAtual]);








    function novo() {
        window.location.href = "/gestao/financas/lancamento/cadastrar"

    }





    const handleMenuClick = (newValue) => {
        setReloadKey(prev => prev + 1);
        if (newValue === 0) {
            //  listarInfoDashboard();
        } else if (newValue === 1) {

            //  listarLancamentos();
        } else if (newValue === 2) {


        } else if (newValue === 10) {

        }

        setValue(newValue);
        setAnchorEl(null);
    };


    return (
        <div >
            {
                !loading && dados &&
                (

                    <Grid item xs={12} container spacing={isMobile ? 4 : 2} style={{ width: '100%', margin: 10 }} direction={'row'} >


                        {isMobile && (
                            <Grid item xs={12} style={{ padding: 10 }}
                            
                            direction={'row'} 
                            justifyContent={'center'}
                             alignItens={'center'}
                            >
                                <Card
                                    style={{
                                        ...styles.card,
                                        ...styles.blueCard,
                                        height: '100px',
                                        padding: 5,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                        textAlign: 'center',
                                        boxShadow: '0px 4px 8px rgba(0,0,0,0.2)',
                                    }}
                                >
                                    <CardContent style={{ padding: 8 }}>
                                        {/* MÊS */}
                                        <TextField
                                            variant="standard"
                                            value={mesAtual}
                                            onChange={(e) => setMesAtual(e.target.value)}
                                            inputProps={{
                                                style: {
                                                    textAlign: 'center',
                                                    fontSize: '2rem',
                                                    fontWeight: 'bold',
                                                    color: '#fff',
                                                    width: '70px',
                                                },
                                                maxLength: 2,
                                            }}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />

                                        {/* ANO */}
                                        <TextField
                                            variant="standard"
                                            value={anoAtual}
                                            onChange={(e) => setAnoAtual(e.target.value)}
                                            inputProps={{
                                                style: {
                                                    textAlign: 'center',
                                                    fontSize: '1rem',
                                                    color: '#e0e0e0',
                                                    letterSpacing: '1px',
                                                    width: '80px',
                                                },
                                                maxLength: 4,
                                            }}
                                            InputProps={{
                                                disableUnderline: true,
                                            }}
                                        />
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}

                        <Grid
                            xs={12} sm={12} md={12} lg={9} xl={9}
                            container spacing={isMobile ? 4 : 2}
                            style={{ width: '100%', paddingTop: isMobile ? 20 : 5, paddingBottom: isMobile ? 20 : 5}} direction={'row'} >

                            <Grid
                                xs={12} sm={12} md={6} lg={6} xl={6}
                                style={{ width: '100%', paddingTop: isMobile ? 20 : 5, 
                                    paddingBottom: isMobile ? 20 : 5 ,
                                 paddingLeft: isMobile ? 0 : 20 ,
                                paddingRight: isMobile ? 0 : 20 
                                }}
                            >
                                <Card style={{ ...styles.card, ...styles.blueCard }}>
                                    <CardContent>
                                        <Box style={styles.iconBox}>
                                            <Box style={styles.iconBackground}>
                                                <AttachMoney />
                                            </Box>
                                        </Box>



                                        <Typography variant="h5">{currencyFormatter.format(dadosMesAtual.totalReceitasPagas)}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <ArrowUpward style={{ fontSize: 14, marginRight: 4 }} />
                                            <Typography variant="body2">{"Recebidos em " + `${mesAtual}/${anoAtual}`}</Typography>
                                        </Box>

                                        <Typography variant="h5">{"  " + currencyFormatter.format(dadosMesAtual.totalReceitasAReceber)}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <ArrowUpward style={{ fontSize: 14, marginRight: 4 }} />
                                            <Typography variant="body2">{"  Receitas a receber em " + `${mesAtual}/${anoAtual}`}</Typography>
                                        </Box>
                                        <Box style={styles.graphBox}></Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid
                                xs={12} sm={12} md={6} lg={6} xl={6}
                                style={{ width: '100%', paddingTop: isMobile ? 20 : 0, paddingBottom: isMobile ? 20 : 0 ,
                                   
                                 paddingLeft: isMobile ? 0 : 20 ,
                                paddingRight: isMobile ? 0 : 20 
                                }}
                            >
                                <Card style={{ ...styles.card, ...styles.purpleCard, position: 'relative', overflow: 'hidden' }}>
                                    <CardContent>
                                        <Box style={styles.iconBox}>
                                            <Box style={styles.iconBackground}>
                                                <ShoppingBasket />
                                            </Box>
                                        </Box>


                                        <Typography variant="h5">{currencyFormatter.format(dadosMesAtual.totalDespesasPagas)}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <ArrowDownward style={{ fontSize: 14, marginRight: 4 }} />
                                            <Typography variant="body2">{"Despesas pagas em " + `${mesAtual}/${anoAtual}`}</Typography>
                                        </Box>

                                        <Typography variant="h5">{"  " + currencyFormatter.format(dadosMesAtual.totalDespesasAPagar)}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <ArrowDownward style={{ fontSize: 14, marginRight: 4 }} />
                                            <Typography variant="body2">{"  Despesas a pagar em " + `${mesAtual}/${anoAtual}`}</Typography>
                                        </Box>


                                    </CardContent>
                                    <Box style={{
                                        position: 'absolute',
                                        top: -200, // aumentei 10 unidades
                                        right: -200, // aumentei 10 unidades
                                        width: 350, // aumentei 20 unidades
                                        height: 350, // aumentei 20 unidades
                                        backgroundColor: '#9673c3', // tom mais claro
                                        borderRadius: '50%',
                                        opacity: 0.5,
                                        zIndex: 1,
                                    }}></Box>
                                    {/* Semicírculo escuro */}
                                    <Box style={{
                                        position: 'absolute',
                                        top: -150, // aumentei 10 unidades
                                        right: -150, // aumentei 10 unidades
                                        width: 400, // aumentei 20 unidades
                                        height: 250, // aumentei 20 unidades
                                        backgroundColor: '#3a1e56', // tom mais escuro
                                        borderRadius: '50%',
                                        opacity: 0.5,
                                        zIndex: 0,

                                    }}></Box>
                                </Card>
                            </Grid>




                            {!loading && (
                                <Grid item xs={12} container>
                                    <ReactApexChart
                                        options={dadosGrafico.options}
                                        series={dadosGrafico.series}
                                        type="line"
                                        height={isMobile ? 400 : 400} // altura responsiva
                                        width={isMobile ?  chartWidth  : 800} // largura responsiva
                                    />
                                </Grid>
                            )}
                        </Grid>

                        <Grid item
                            xs={12} sm={12} md={12} lg={3} xl={3}
                            container style={{ width: '100%' }} spacing={isMobile ? 2 : 1} direction={'row'} justifyContent={'flex-start'} alignItens={'flex-start'} >


                            {!isMobile && (
                                <Grid item xs={12}>
                                    <Card
                                        style={{
                                            ...styles.card,
                                            ...styles.blueCard,
                                            height: '100px',
                                            padding: 5,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                            textAlign: 'center',
                                            boxShadow: '0px 4px 8px rgba(0,0,0,0.2)',
                                        }}
                                    >
                                        <CardContent style={{ padding: 8 }}>
                                            {/* MÊS */}
                                            <TextField
                                                variant="standard"
                                                value={mesAtual}
                                                onChange={(e) => setMesAtual(e.target.value)}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'center',
                                                        fontSize: '2rem',
                                                        fontWeight: 'bold',
                                                        color: '#fff',
                                                        width: '70px',
                                                    },
                                                    maxLength: 2,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />

                                            {/* ANO */}
                                            <TextField
                                                variant="standard"
                                                value={anoAtual}
                                                onChange={(e) => setAnoAtual(e.target.value)}
                                                inputProps={{
                                                    style: {
                                                        textAlign: 'center',
                                                        fontSize: '1rem',
                                                        color: '#e0e0e0',
                                                        letterSpacing: '1px',
                                                        width: '80px',
                                                    },
                                                    maxLength: 4,
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                            />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}


                            <Grid item xs={12}>
                                <Card style={{ ...styles.card, ...styles.purpleCard, height: '100px', padding: 5, flexDirection: 'row' }}>
                                    <CardContent>
                                        <Box style={styles.iconBox}>
                                            <Box style={styles.iconBackground}>
                                                <ShoppingBasket />
                                            </Box>
                                            <Typography variant="h5" style={{ fontWeight: 'bold' }}>{currencyFormatter.format(dados.totalDespesas) + ""}</Typography>
                                        </Box>
                                        <Box display="flex" alignItems="center">
                                            <ArrowDownward style={{ fontSize: 14 }} />
                                            <Typography variant="body2">{"Despesa Total"}</Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} >
                                <Card style={{ ...styles.card, backgroundColor: 'white', height: '300px', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.5)' }}>
                                    <CardContent>

                                        <Typography variant="h6" style={{ color: 'black', fontWeight: 'bold' }}>{"Vence Hoje"}</Typography>
                                        <br></br>
                                        <Typography variant="h4" style={{ color: '#6a1b9a', fontWeight: 'bold' }}>{currencyFormatter.format(dadosMesAtual.totalDespesasVenceHoje)}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <ArrowDownward style={{ fontSize: 14 }} />
                                            <Typography variant="body2" style={{ color: '#6a1b9a', fontWeight: 'bold' }}>{"a pagar"}</Typography>
                                        </Box>
                                        <br></br>
                                        <br></br>
                                        <Typography variant="h4" style={{ color: '#0288d1', fontWeight: 'bold' }}>{currencyFormatter.format(dadosMesAtual.totalReceitasVenceHoje)}</Typography>
                                        <Box display="flex" alignItems="center">
                                            <ArrowUpward style={{ fontSize: 14 }} />
                                            <Typography variant="body2" style={{ color: '#0288d1', fontWeight: 'bold' }}>{"a receber"}</Typography>
                                        </Box>

                                    </CardContent>
                                </Card>
                            </Grid>


                            <Grid item xs={12} >


                            </Grid>

                        </Grid>


                         <Grid container spacing={3}>
    <Grid item xs={12} md={6}>
        <h3>Despesas por Conta</h3>
        <ReactApexChart
            options={graficoDespesas.options}
            series={graficoDespesas.series}
            type="pie"
            height={isMobile ? 400 : 400} // altura responsiva
            width={isMobile ? '100%' : undefined} // largura responsiva
        />
        <Box mt={1} textAlign="center">
            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                Total: {currencyFormatter.format(graficoDespesas.series.reduce((acc, val) => acc + val, 0), { code: 'BRL' })}
            </Typography>
        </Box>
    </Grid>

    <Grid item xs={12} md={6}>
        <h3>Receitas por Conta</h3>
        <ReactApexChart
            options={graficoReceitas.options}
            series={graficoReceitas.series}
            type="pie"
            height={isMobile ? 300 : 400} // altura responsiva
            width={isMobile ? '100%' : undefined} // largura responsiva
        />
        <Box mt={1} textAlign="center">
            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                Total: {currencyFormatter.format(graficoReceitas.series.reduce((acc, val) => acc + val, 0), { code: 'BRL' })}
            </Typography>
        </Box>
    </Grid>
</Grid>


                    </Grid>

                )
            }






        </div>
    );
}


